import { render } from "./snippet-preview.vue?vue&type=template&id=766bc005"
import script from "./snippet-preview.vue?vue&type=script&lang=js"
export * from "./snippet-preview.vue?vue&type=script&lang=js"

import exportComponent from "E:\\PhpstormProjects\\zoodkomak_tv_panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__